export const ADMIN_LOGIN_NOTICE_KEY = 'admin_login_notice';
export const ADMIN_SESSION_EXPIRED_NOTICE = 'Your session is no longer valid. Sign in again.';
